import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch  } from 'react-redux';
import { getCountriesFetch } from '../redux/state/countryState';

import styled from 'styled-components';
import Grid from '../components/UI/Grid';
import StatCard from '../components/UI/StatCard';
import CountryCard from '../components/UI/CountryCard';
import CountryStatList from '../components/CountryStatList';

import useFetch from '../hooks/useFetch';
import { WORLDWIDE_DATA } from '../constants/links';
import { formatNumber, convertTime, filterCountries } from '../utils';


const Home = () => {
    const dispatch = useDispatch();
    const [userCountry, setUserCountry] = useState('Canada');
    const [userCountryData, setUserCountryData] = useState();

    const data = useFetch(WORLDWIDE_DATA);
    const userLocation = useFetch('https://ipapi.co/json/');
    const countries = useSelector((state) => state.countries.countries);

    useEffect(() => {
        if (userLocation.length > 0) {
            setUserCountry(userLocation.country_name);
        }
        setUserCountryData(filterCountries(countries, userCountry));
    }, [userLocation, countries, userCountry]);

    useEffect(() => {
        dispatch(getCountriesFetch());
    }, [dispatch]);

    return <StyledHome>
        {userCountryData && <>
            <Grid cols={3} colsMd={3} colsSm={1}>
                <h2 className="header">Stats for {userCountry}</h2>
            </Grid>
            <CountryStatList country={userCountryData} />
            <hr />
        </>}  
      
        <Grid cols={3} colsMd={2} colsSm={1}>
            <h2 className="header">Global Statistics</h2>
        </Grid>
        {data && <Grid cols={4} colsMd={2} colsSm={1}>
            <StatCard title="Total Cases" info={formatNumber(data.cases)} variant="warning" />
            <StatCard title="Active Cases" info={formatNumber(data.active)} variant="info" />
            <StatCard title="Total Recoveries" info={formatNumber(data.recovered)} variant="success" />
            <StatCard title="Total Deaths" info={formatNumber(data.deaths)} variant="danger" />
            <StatCard title="Cases Today" info={formatNumber(data.todayCases)} variant="warning" />
            <StatCard title="Tests" info={formatNumber(data.tests)} variant="info" />
            <StatCard title="Affected Countries" info={formatNumber(data.affectedCountries)} variant="default" />
            <StatCard title="Last Updated" info={convertTime(data.updated/1000)} variant="default" />
        </Grid>}
        <hr />
        <Grid cols={3} colsMd={2} colsSm={1}>
            <h2>Available Countries</h2>
        </Grid>
        <Grid cols={6} colsMd={2} colsSm={1}>
            {countries.map((country, index) => <CountryCard key={country.country + index} country={country} />)}
        </Grid>
    </StyledHome>;
};

const StyledHome = styled.div`
    padding: 2rem 0;
    
    .header {
        margin-top: 2rem;
        margin-bottom: 1rem;
        font-size: 2rem;
        font-weight: 700;
        background: ${({ theme }) => theme.gradient};
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }

    h2 {
        font-size: 1.75rem;
        font-weight: 700;
        margin-bottom: 1rem;
        color: ${({ theme }) => theme.text};
    }

    hr {
        width: 90%;
        margin: 3rem auto;
        border: none;
        height: 1px;
        background: linear-gradient(
            to right,
            transparent,
            ${({ theme }) => theme.textSecondary}40,
            transparent
        );
    }
`;


export default Home;
